import * as React from 'react';
import { routeNode, IRouteNodeProps } from 'react-mobx-router5';
import Loadable from 'react-loadable';

// Constants
import { ROUTE_PATHS, ROUTE_NAMES } from '../../constants/routes';

// Components
import Box from '../../components/Box';
import { CircularProgress } from '../../components/Progress';

import AppNetworkNotifcations from '../AppNetworkNotifcations';
import AppNetworkHome from '../AppNetworkHome';
import AppNetworkPeople from '../AppNetworkPeople';
import AppNetworkQuestions from '../AppNetworkQuestions';

// React Loadable
const LoadableAppNetworkAdministration = Loadable({
  loader: () => import('../AppNetworkAdministration'),
  loading() {
    return (
      <Box pa={5} align="center">
        <CircularProgress />
      </Box>
    );
  }
});

// Component
export interface IProps extends IRouteNodeProps {}

class Router extends React.Component<IProps, {}> {
  render() {
    if (!this.props.route) {
      return <h1>Page not found</h1>;
    }
    const segment = this.props.route.name.split('.')[2];
    switch (segment) {
      case ROUTE_NAMES.APP_NETWORK_NOTIFICATIONS:
        return <AppNetworkNotifcations />;
      case ROUTE_NAMES.APP_NETWORK_HOME:
        return <AppNetworkHome />;
      case ROUTE_NAMES.APP_NETWORK_PEOPLE:
        return <AppNetworkPeople />;
      case ROUTE_NAMES.APP_NETWORK_QUESTIONS:
        return <AppNetworkQuestions />;
      case ROUTE_NAMES.APP_NETWORK_ADMINISTRATION:
        return <LoadableAppNetworkAdministration />;
      default:
        return <h1>Something went wrong...</h1>;
    }
  }
}

export default routeNode(ROUTE_PATHS.APP_NETWORK)(Router);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/views/AppNetwork/Router.tsx